export default function Footer() {
  return (
    <footer className="bg-black text-gray-300 px-8 md:px-20 py-24 min-h-screen flex flex-col justify-between">
      
      {/* Main Content */}
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 md:grid-cols-4 gap-16 mt-10 flex-grow">

        {/* Column 1 */}
        <div>
          <h3 className="text-white text-2xl font-semibold mb-6">Ledot Prime</h3>
          <p className="text-sm leading-7 text-gray-400">
            GPS tracking, auto-security, and fleet monitoring solutions for businesses,
            commercial drivers, and fleet owners across Africa.  
          </p>
        </div>

        {/* Column 2 */}
        <div>
          <h4 className="text-white text-lg font-semibold mb-6">Services</h4>
          <ul className="space-y-4 text-sm">
            <li>GPS Car Tracking</li>
            <li>Motorbike Tracking</li>
            <li>Fleet Monitoring</li>
            <li>Engine Lock / Unlock</li>
          </ul>
        </div>

        {/* Column 3 */}
        <div>
          <h4 className="text-white text-lg font-semibold mb-6">Company</h4>
          <ul className="space-y-4 text-sm">
            <li>About Us</li>
            <li>Pricing</li>
            <li>Contact</li>
            <li>Partners</li>
          </ul>
        </div>

        {/* Column 4 */}
<div>
  <h4 className="text-white text-lg font-semibold mb-6">Connect</h4>
  <ul className="space-y-4 text-sm">
    <li>
      <a
        href="https://wa.me/233508499531"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-all duration-300 transform hover:text-green-400 hover:translate-x-2"
      >
        WhatsApp
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com/ledotprime"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-all duration-300 transform hover:text-pink-500 hover:translate-x-2"
      >
        Instagram
      </a>
    </li>
    <li>
      <a
        href="https://web.facebook.com/ledotprime.gh"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-all duration-300 transform hover:text-blue-500 hover:translate-x-2"
      >
        Facebook
      </a>
    </li>
    <li>
      <a
        href="https://twitter.com/ledot_prime"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-all duration-300 transform hover:text-sky-400 hover:translate-x-2"
      >
        Twitter
      </a>
    </li>
  </ul>
</div>



      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 pt-8 pb-4 text-center">
        <p className="text-sm text-gray-500 tracking-wide">
          © {new Date().getFullYear()} Ledot Prime. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
